import { Injectable } from '@angular/core';

import { SwipeActionsDirective } from './swipe-actions.directive';

@Injectable({ providedIn: 'root' })
export class SwipeManagerService {
    private activeSwipe: SwipeActionsDirective | null = null;

    setActiveSwipe(swipe: SwipeActionsDirective): void {
        if (this.activeSwipe && this.activeSwipe !== swipe) {
            this.activeSwipe.closeFromRight();
        }
        this.activeSwipe = swipe;
    }

    clearActiveSwipe(swipe: SwipeActionsDirective): void {
        if (this.activeSwipe === swipe) {
            this.activeSwipe = null;
        }
    }

    closeActiveSwipe(): void {
        this.activeSwipe?.closeFromRight();
    }

    hasActiveSwipe(): boolean {
        return this.activeSwipe != null;
    }
}
